var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Square(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.75V14.535C9 15.9375 8.4375 16.5 7.0275 16.5H3.465C2.0625 16.5 1.5 15.9375 1.5 14.535V10.9725C1.5 9.5625 2.0625 9 3.465 9H5.25V10.7775C5.25 12.1875 5.8125 12.75 7.215 12.75H9Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9V10.7775C12.75 12.1875 12.1875 12.75 10.7775 12.75H7.215C5.8125 12.75 5.25 12.1875 5.25 10.7775V7.215C5.25 5.8125 5.8125 5.25 7.215 5.25H9V7.0275C9 8.4375 9.5625 9 10.965 9H12.75Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.465V7.0275C16.5 8.4375 15.9375 9 14.5275 9H10.965C9.5625 9 9 8.4375 9 7.0275V3.465C9 2.0625 9.5625 1.5 10.965 1.5H14.5275C15.9375 1.5 16.5 2.0625 16.5 3.465Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Square);
export default __webpack_public_path__ + "static/media/3square.bd3f67854e7eb34e75af53785cb5e263.svg";
export { ForwardRef as ReactComponent };